import { BillingCycle } from 'models/bundle'

export const ALLOWED_PLANS = [
  // 'creator-organization-v5-developing-annual',
  // 'creator-organization-v5-developing-quarterly',
  // 'creator-pro-v5-developing-annual',
  // 'creator-pro-v5-developed-quarterly',
  // 'creator-pro-plus-v5-developing-annual',
  // 'creator-pro-v5-developing-quarterly',
  // 'creator-starter-v5-developing-annual',
  // 'creator-starter-v5-developing-monthly',
  // 'cu-sta-0101-monthly-dm',
  // 'cu-sta-0101-qtr-dm',
  // 'cu-sta-0101-annual-dm',
  // 'cu-pro-0101-qtr-dm',
  // 'cu-pro-0101-annual-dm',
  // 'cu-ent-0101-qtr-dm',
  // 'cu-ent-0101-annual-dm',
  'cu-pro-0200-annual-dm',
  'cu-bus-0200-annual-dm',
  'cu-gro-0200-annual-dm',
  'cu-ent-0200-annual-dm',
]
export const REFFERAL_ALLOWED_PLANS = [
  'creator-pro-v5-developing-annual',
  'creator-pro-v5-developed-quarterly',
  'creator-pro-plus-v5-developing-annual',
  'creator-pro-v5-developing-quarterly',
  'creator-starter-v5-developing-annual',
  'creator-starter-v5-developing-monthly',
  'cu-sta-0101-monthly-dm',
  'cu-sta-0101-qtr-dm',
  'cu-sta-0101-annual-dm',
  'cu-pro-0101-qtr-dm',
  'cu-pro-0101-annual-dm',
  'cu-ent-0101-annual-dm',
  'cu-pro-0200-quarterly-dm',
  'cu-bus-0200-quarterly-dm',
  'cu-gro-0200-quarterly-dm',
  'cu-ent-0200-quarterly-dm',
  'cu-pro-0200-annual-dm',
  'cu-bus-0200-annual-dm',
  'cu-gro-0200-annual-dm',
  'cu-ent-0200-annual-dm',
]

export const ALLOWED_PERIODS: BillingCycle[] = ['yearly']
export const PLAN_ORDER = ['cu-pro', 'cu-bus', 'cu-gro', 'cu-ent']
export const getPlanPrefix = (id: string) => {
  // Extract 'cu-pro', 'cu-bus', etc.
  return id.split('-').slice(0, 2).join('-') // e.g., 'cu-pro'
}

export function shouldShowContactSalesButton(planId?: string): boolean {
  if (!planId) return false
  const is0200 = planId.includes('0200')
  const matchesTier =
    planId.includes('bus') ||
    planId.includes('gro') ||
    planId.includes('ent')

  return is0200 && matchesTier
}
export function is0200Plan(planId?: string): boolean {
  if (!planId) return false
  return planId.includes('0200')
}

export const planMapping = {
  'creator-starter-v5-developing-monthly': 'cu-sta-0101-monthly-dm',
  'creator-starter-v5-developing-annual': 'cu-sta-0101-annual-dm',
  'creator-pro-v5-developing-quarterly': 'cu-pro-0101-qtr-dm',
  'creator-pro-plus-v5-developing-annual': 'cu-pro-0101-annual-dm',
  'creator-pro-v5-developed-quarterly': 'cu-pro-0101-qtr-dm',
  'creator-pro-v5-developing-annual': 'cu-pro-0101-annual-dm',
  'creator-organization-v5-developing-quarterly': 'cu-ent-0101-qtr-dm',
  'creator-organization-v5-developing-annual': 'cu-ent-0101-annual-dm',
}